<div class="customer-legacy-contacts">
  <div class="heading">
    <div>
      <span>{{ 'label.OtherInfo' | translate }}</span>
    </div>
    <div>
      <a
        *ngIf="customer?.statusId == customerStatusEnum.Active"
        [routerLink]="
          customer ? ['/customers/edit/', customer?.customerId, 'details'] : []
        "
        >{{ 'label.Edit' | translate }}</a
      >
    </div>
  </div>
  <div class="content">{{ customer?.legacyContactInfo }}</div>
</div>
